import { mapState } from 'vuex'
const langArray = ['zh-CN', 'en-US', 'id', 'fr', 'th-TH', 'vi', 'ar']
export const storeState = {
  computed: {
    ...mapState({
      customer: (state) => state.customer,
      business: (state) => state.business,
      stock: (state) => state.stock,
      currency: (state) => state.currency,
      employee: (state) => state.employee,
      supply: (state) => state.supply,
      payment: (state) => state.payment,
      category: (state) => state.category,
    }),
  },
  methods: {
    setLabelWidthByLang(labelWidths) {
      if ('fr' === this.$store.state.sys.lang) return labelWidths[1]
      if ('th-TH' === this.$store.state.sys.lang) return labelWidths[2]
      if ('vi' === this.$store.state.sys.lang) return labelWidths[1]
      const index = langArray.findIndex((lang) => lang === this.$store.state.sys.lang)
      if (labelWidths[index] === void 0) return 'auto'
      return labelWidths[index]
    },
  },
}
